// For Owl carousel on Home Page
$('.home-banner-slider').owlCarousel({
    loop: true,
    margin: 10,
    nav: false,
    dots: true,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        1000: {
            items: 1
        }
    }
})

// For categories on home page
$(".category-btn1").click(function () {
    $(".dropdown-category-1 ").slideToggle();
})

$(".category-btn2").click(function () {
    $(".dropdown-category-2 ").slideToggle();
})

// For hamburger
$(document).ready(function(){
	$(".hamburger button").click(function(){
		$(this).toggleClass('active');
        $("nav.navbar").toggleClass('active');
	});
});

// For Overlay 
$(document).ready(function(){
	$(".hamburger button").click(function(){
        $(".overlay").toggleClass('active');
        $("body").toggleClass('active');
	});
});

// Tabbing on Blog Page
$(".tabContent").hide();
    $("ul.tabs li:first").addClass("active").show();
    $(".tabContent:first").show();

    $("ul.tabs li").click(function () {
        $("ul.tabs li").removeClass("active");
        $(this).addClass("active");
        $(".tabContent").hide();
        var activeTab = $(this).find("a").attr("href");
        $(activeTab).fadeIn();
        return false;
    });

var elementToView = document.getElementById("home-categories");
elementToView.scrollIntoView({behavior: "smooth"}); 

document.querySelector(".grid-load-more__btn").classList.add("load-more-btn");

console.log("hello");
